<template>
  <div id="app">
    <div v-if="isManagingSessions" id="app-loading">
      <a-spin size="large"/>
      <!--<a-spin />-->
    </div>
    <a-layout v-else>
      <a-layout-header v-if="isSignedIn">
        <router-link to="/batch-history">Batch History</router-link>
        <div class="spacer"></div>
        <span><a-button @click="signOut" id="logout-button">Sign out</a-button></span>
      </a-layout-header>
      <a-layout-content>
        <router-view />
      </a-layout-content>
      <footer>{{ts}}</footer>
    </a-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {

  computed: {
    ...mapGetters('auth', ["isSignedIn", "isManagingSessions"]),
  },
  data() {
    return {
      // ts: document.documentElement.dataset.buildTs
      ts: `(c) ${new Date().getFullYear()}, All rights reserved.`,
    };
  },
  methods: {
    ...mapActions('auth', ["signOut"]),
  },
  name: "app"
};
</script>
<style lang="scss">
@import "./assets/scss/main.scss";
#app {
  text-align: center;
}
.ant-layout-header {
  background-color: #fff;
  display: flex;
  align-items: center;
  line-height: 62px;

  a {
    font-size: 20px;
    display: inline-block;
    border-bottom: solid 2px #fff;

    &:focus {
      text-decoration: none;
    }

    &.router-link-exact-active {
      border-color: #1890ff;
    }
  }
}
.logo {
  max-height: 40px;
  margin-right: 20px;
}
.spacer {
  flex-grow: 1;
}
.ant-layout-content {
  background-color: #fff;
  padding: 50px;
  text-align: left;
  min-height: 90vh;

  @media (max-width: 500px) {
    padding: 10vw;
  }
}
footer {
  padding: 20px;
  font-size: 12px;
  color: #999;
  text-align: right;
}

#logout-button {
  background: #f90;
  color: #fff;

  min-width: 153px;
  min-height: 50px;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;

  text-transform: uppercase;
  letter-spacing: 1.1px;
  border: none;
  border-radius: unset;

  &:hover {
    opacity: .7;
  }
}

#app-loading {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
}

</style>
